function getOrCreateLegendList (chart, id, direction) {
	const legendContainer = document.getElementById(id)
	let listContainer = legendContainer.querySelector('ul')

	if (!listContainer) {
		listContainer = document.createElement('ul')
		listContainer.style.display = 'flex'
		listContainer.style.margin = 0
		listContainer.style.padding = 0
		listContainer.style.flexDirection = direction

		if (direction === 'row') {
			listContainer.style.justifyContent = 'space-evenly'
		}

		legendContainer.appendChild(listContainer)
	}

	return listContainer
}

export default {
	methods: {
		htmlLegendPlugin (containerId, direction = 'column') {
			return {
				id: containerId,
				afterUpdate (chart, args, options) {
					const ul = getOrCreateLegendList(chart, containerId, direction)

					// Remove old legend items
					while (ul.firstChild) {
						ul.firstChild.remove()
					}

					// Reuse the built-in legendItems generator
					const items = chart.options.plugins.legend.labels.generateLabels(chart)
					items.forEach(item => {
						const li = document.createElement('li')
						li.style.alignItems = 'center'
						li.style.cursor = 'pointer'
						li.style.display = 'flex'
						li.style.flexDirection = 'row'
						li.style.marginLeft = '10px'
						li.style.padding = '8px 0px'
						item.value = chart.data.datasets[0].data[item.index]
						li.onclick = () => {
							const { type } = chart.config
							if (type === 'pie' || type === 'doughnut') {
								// Pie and doughnut charts only have a single dataset and visibility is per item
								chart.toggleDataVisibility(item.index)
								item.hidden = !item.hidden
								li.style.textDecoration = item.hidden ? 'line-through' : ''
							} else {
								chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex))
							}
							chart.update()
						}

						// Color box
						const boxSpan = document.createElement('span')
						boxSpan.style.background = item.fillStyle
						boxSpan.style.borderColor = item.strokeStyle
						boxSpan.style.borderWidth = item.lineWidth + 'px'
						boxSpan.style.display = 'inline-block'
						boxSpan.style.flexShrink = 0
						boxSpan.style.height = '20px'
						boxSpan.style.marginRight = '10px'
						boxSpan.style.width = '20px'
						boxSpan.style.borderRadius = '50%'

						// Text
						const textContainer = document.createElement('p')
						textContainer.style.color = item.fontColor
						textContainer.style.margin = 0
						textContainer.style.padding = 0

						const text = document.createTextNode(`${item.text}: `)
						textContainer.appendChild(text)

						const labelTotal = document.createElement('span')
						labelTotal.innerText = item.value

						li.appendChild(boxSpan)
						li.appendChild(textContainer)
						textContainer.appendChild(labelTotal)
						ul.appendChild(li)

						textContainer.classList.add('font-weight-bold')
						labelTotal.classList.add('font-weight-light')
					})
				}
			}
		}
	}
}
